import { render } from "./promo-codes.vue?vue&type=template&id=798a4c6f"
import script from "./promo-codes.vue?vue&type=script&lang=js"
export * from "./promo-codes.vue?vue&type=script&lang=js"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__